﻿import { IRoutingComponent } from "@fiqas/ngcomponentrouter"
import { Inject, Component } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { AuthenticationService } from "../../services/authenticationService";
import { SessionService } from "../../services/session";
import { HomeService } from "../../services/fiqassistApi/homeService";
import { StartVersion } from "../../models/version";
import { AuthorizationService } from "../../services/authorizationService";

@Component({
    module: FIQAssist,
    selector: "login",
    templateUrl: "views/login.html",
    bindings: { $router: '<' }
})

class Login implements IRoutingComponent {
    constructor(
        @Inject('$window') private $window: ng.IWindowService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject('$location') private $location: angular.ILocationService,
        @Inject('$rootRouter') private $rootRouter: angular.Router,
        @Inject() private homeService: HomeService,
        @Inject() private authenticationService: AuthenticationService,
        @Inject() private authorizationService: AuthorizationService
    ) {
    }
    private source: string;
    private isWrong: boolean = false;
    public $routerCanReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction): ng.IPromise<boolean> | boolean {
        this.source = decodeURIComponent(next.params['source']);
        return true;
    }

    public async $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
        this.source = decodeURIComponent(next.params['source']);
        if (this.authenticationService.isAlive()) {
             await this.authorizationService.roleLoaded;
            this.redirectToNextPage();
        }
    }

    public async $routerOnReuse(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction) {
        this.source = decodeURIComponent(next.params['source']);
        if (this.authenticationService.isAlive()) {
             await this.authorizationService.roleLoaded;
            this.redirectToNextPage();
        }
    }

    private $router: angular.Router;

    public $onInit() {
        this.username = localStorage.getItem("REMEMBERUSER");
        this.persistent = !!localStorage.getItem("REMEMBERME");
    }

    public async $postLink() {
        if (this.authenticationService.isAlive()) {
             await this.authorizationService.roleLoaded;
            this.redirectToNextPage();
        }
    }

    private redirectToNextPage() {
        if (this.$location.url().indexOf("/login") >= 0 || this.$location.url().indexOf("/goodbye")) {
            if (this.source) {
                this.$rootRouter.navigateByUrl(this.source);
            } else {
                this.$rootRouter.navigate(["Home", { menu: true }]);
            }
        }
    }

    public async login() {
        if (!this._loggingIn) {
            this._loggingIn = true;
            try {
                await this.authenticationService.authenticate({ username: this.username, password: this.password }, this.persistent || false)

                if (this.homeService.fiqassistApiVersion == HomeService.ApiNotAvailible) {
                    this.homeService.recieveAPIVersion(() => {});
                }

                localStorage.setItem("REMEMBERUSER", this.username);
                localStorage.setItem("REMEMBERME", (this.persistent) ? "1" : "");

                 await this.authorizationService.roleLoaded;
                this.redirectToNextPage();
            } catch (reason) {
                this.isWrong = true;
            } finally {
                this._loggingIn = false
            };
        }
    }
    private _loggingIn = false;

    public username: string;
    public password: string;
    public persistent: boolean;

    private onUserChanged(value: string): void {
        this.username = value;
        this.isWrong = false;
    }

    private onPasswordChanged(value: string): void {
        this.password = value;
        this.isWrong = false;
    }

    public persistentChanged(value: boolean): void {
        this.persistent = value;
    }
}
